import { render } from "./UsefullLinks.vue?vue&type=template&id=7cac747d&ts=true"
import script from "./UsefullLinks.vue?vue&type=script&lang=ts"
export * from "./UsefullLinks.vue?vue&type=script&lang=ts"

import "./UsefullLinks.vue?vue&type=style&index=0&id=7cac747d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__